import { MALOMO_PUBLIC_KEY } from "utils/constants";

const malomoApiRequest = async (endpoint) => {
	try {
		const response = await fetch(`https://api.gomalomo.com/orders/${endpoint}`, {
			method: "GET",
			redirect: "follow",
			headers: {
				Authorization: `Bearer ${MALOMO_PUBLIC_KEY}`,
				Accept: "application/vnd.malomo+json; version=2",
			}
		});

		const data = await response.json();
		return data;
	} catch (error) {
		console.log("error", error.response.data);
		return null;
	}
};

export const fetchOrderByBumberAndMail = (orderNumber, email) =>
	malomoApiRequest(`?number=${orderNumber}&customer_email=${email}`);

export const fetchOrderByTrackingCode = (trackingCode) => malomoApiRequest(`?tracking_code=${trackingCode}`);

export const fetchOrderById = (id) => malomoApiRequest(id);

export const fetchOrderByAlternateId = (alternate_id) => malomoApiRequest(`?alternate_id=${alternate_id}`);